/**
 * Created by Ning Jiang on 11/22/2016.
 */

///<reference path="../../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomEase.d.ts"/>
require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomEase.js");
require("../../node_modules/gsap/src/uncompressed/plugins/PixiPlugin");
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FruitsBasicBackground} from "./background/FruitsBasicBackground";
import {FruitsGameModuleConfig} from "./FruitsGameModuleConfig";
import {FruitsBigWinView} from "./winpresentation/bigwin/FruitsBigWinView";
import {FruitsInitialWPView} from "./winpresentation/initial/FruitsInitialWPView";

export class Fruits extends SlotGame {

    public static bigWinView:FruitsBigWinView;
    public static initialView:FruitsInitialWPView;
    public static basicBackground:FruitsBasicBackground;

    constructor() {
        super(FruitsGameModuleConfig.instance);
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "M1",
                    "M2",
                    "M4"
                ],
                [
                    "M1",
                    "M5",
                    "M4"
                ],
                [
                    "M5",
                    "L1",
                    "M1"
                ],
                [
                    "M6",
                    "L3",
                    "L1"
                ],
                [
                    "M6",
                    "L1",
                    "L1"
                ],
                [
                    "M6",
                    "L2",
                    "L2"
                ]
            ],
            "evaluatedArea": [
                [
                    "M1",
                    "M2",
                    "M4"
                ],
                [
                    "M1",
                    "M5",
                    "M4"
                ],
                [
                    "M5",
                    "L1",
                    "M1"
                ],
                [
                    "M6",
                    "L3",
                    "L1"
                ],
                [
                    "M6",
                    "L1",
                    "L1"
                ],
                [
                    "M6",
                    "L2",
                    "L2"
                ]
            ],
            "betLineWins": [],
            "totalBetLineWinnings": 0,
            "totalSpinWinnings": 0,
            "totalSpinWinningsMultiplied": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "nearWinPositions": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "bigWinExcitementPositions": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "reelsNextSpin": "BASE_REELSET",
            "nearWinPositionsPortrait": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "bigWinExcitementPositionsPortrait": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "isStickyRespinTriggeredThisSpin": false,
            "isBonusTriggeredThisSpin": false,
            "numberOfSpinsPlayed": 0,
            "numberOfSpinsRemaining": 0,
            "numberOfBonusSpinsPlayed": 0,
            "numberOfBonusSpinsRemaining": 0,
            "overlayStickySymbolsAfterSpin": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "newOverlayStickySymbols": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "overlayStickySymbolsBeforeSpin": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "stickySymbol": "",
            "bonusTimesBetCollectedBeforeSpin": 0,
            "bonusTimesBetCollectedAfterSpin": 0,
            "bonusTimesBetLandValue": [
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ]
            ],
            "bonusSpecialSymbolExtraSpin": [
                [
                    false,
                    false
                ],
                [
                    false,
                    false
                ]
            ],
            "bonusNumberOfExtraSpinAdded": 0,
            "bonusSpecialSymbolMultiplier": [
                [
                    false,
                    false
                ],
                [
                    false,
                    false
                ]
            ],
            "bonusExtraMultiplier": 0,
            "winPositions": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "scatterPositions": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "bonusOverlayPositionsBefore": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "bonusOverlayPositionsAfter": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "newBonusOverlayPositions": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "bonusPayTableBeforeSpin": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "bonusPayTableAfterSpin": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "numberOfUpgradesBefore": 0,
            "numberOfUpgradesAfter": 0,
            "numberOfUpgradesThisSpin": 0,
            "upgradeTriggered": false,
            "collectedScatterBefore": 0,
            "collectedScatterAfter": 0,
            "finalBonusWin": 0,
            "symbolOverlayPositions": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "randomSymbolOverlayTriggered": false,
            "randomOverlaySymbol": "",
            "numberOfOverlaySymbols": 0,
            "isExcitementSpinTriggered": false,
            "isExcitementSpinTriggeredPortrait": false,
            "overlaySymbolsBeforeSpin": [
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ]
            ],
            "overlaySymbolsAfterSpin": [
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ]
            ]
        };
    }
}